import { Gender } from '@dreryk/egabinet-patient-frontend-api';

import { isUndefined } from '~libs.typescript';

import { PatientDataAccessMode } from '../types';

const PATIENT_DATA_ACCESS_MODES: PatientDataAccessMode[] = ['STANDARD', 'SPECIAL', 'SPECIAL_PREGNANCY'];
const DEFAULT_DATA_ACCESS_MODE = 'STANDARD';
const PATIENT_PREGNANT_ACCESS_MODE_LOWER_AGE_THRESHOLD = 18;
const PATIENT_PREGNANT_ACCESS_MODE_UPPER_AGE_THRESHOLD = 66;
const PATIENT_SPECIAL_ACCESS_MODE_LOWER_AGE_THRESHOLD = 18;
const PATIENT_SPECIAL_ACCESS_MODE_UPPER_AGE_THRESHOLD = 65;

export const getPatientDataAccessModes = (): PatientDataAccessMode[] => {
   return PATIENT_DATA_ACCESS_MODES;
};

export const isPatientDataAccessMode = (value: string | undefined): value is PatientDataAccessMode => {
   if (isUndefined(value)) {
      return false;
   }

   return PATIENT_DATA_ACCESS_MODES.some((applicableValue) => applicableValue === value);
};

export const isPatientWithinAgeRangeForPregnancyAccessMode = (patientAge: number): boolean => {
   return (
      patientAge >= PATIENT_PREGNANT_ACCESS_MODE_LOWER_AGE_THRESHOLD &&
      patientAge <= PATIENT_PREGNANT_ACCESS_MODE_UPPER_AGE_THRESHOLD
   );
};

export const isPatientSpecialModeAvailable = (patientAge: number): boolean => {
   return (
      patientAge < PATIENT_SPECIAL_ACCESS_MODE_LOWER_AGE_THRESHOLD ||
      patientAge >= PATIENT_SPECIAL_ACCESS_MODE_UPPER_AGE_THRESHOLD
   );
};

export const isPregnantModeAvailable = (patientGender: Gender, patientAge: number): boolean => {
   return patientGender === 'WOMAN' && isPatientWithinAgeRangeForPregnancyAccessMode(patientAge);
};

export const isAnySpecialModeAvailable = (patientGender: Gender, patientAge: number): boolean => {
   return isPatientSpecialModeAvailable(patientAge) || isPregnantModeAvailable(patientGender, patientAge);
};

export const getPatientDataAccessModeDefaultValue = (
   patientDataAccessMode: PatientDataAccessMode,
   patientGender: 'MAN' | 'WOMAN' | 'UNKNOWN',
   patientAge: number
): PatientDataAccessMode => {
   if (patientDataAccessMode === 'SPECIAL' && !isPatientSpecialModeAvailable(patientAge)) {
      return 'STANDARD';
   }

   if (patientDataAccessMode === 'SPECIAL_PREGNANCY' && !isPregnantModeAvailable(patientGender, patientAge)) {
      return 'STANDARD';
   }

   return patientDataAccessMode ?? DEFAULT_DATA_ACCESS_MODE;
};
